const INTEREST_STATES = [
  { label: 'Interested', value: 'interested' },
  { label: 'Not interested', value: 'not_interested' },
  // TODO: 'unset' filtering makes query super slow, must be first fixed at the backend
  // { label: 'Not specified yet', value: 'unset' },
]

export function getInterestStates() {
  return INTEREST_STATES
}

export default INTEREST_STATES
export const interestStatesChoices = INTEREST_STATES
